import React, { useContext, useState } from "react";
import { FaWallet } from "react-icons/fa";
import styles from "../../styles/Profile/Transaction.module.css";
import TransactionItem from "./TransactionItem";

import authContext from "../../context/auth/authContext";
import moment from "moment";
import axios from "axios";
import { FcInfo } from "react-icons/fc";
import ReactTooltip from "react-tooltip";
import { formatPrice } from "../../helpers/format";
import cryptoContext from "../../context/crypto/cryptoContext";
import NumberFormat from "react-number-format";

import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../components/Loader";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import dotenv from "dotenv";
import {Link} from "react-router-dom";
dotenv.config();
const Transaction = ({ history }) => {
  const {
    userData,
    getAmountInWallet,
    walletData: data,
  } = useContext(authContext);

  const { exchangeRate } = useContext(cryptoContext);

  const [showInput, setShowInput] = useState(false);
  const [money, setMoney] = useState(100);
  const [pageNo, setPageNo] = useState(2);
  const [paymentLoading, setPaymentLoading] = useState(false);
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    setPaymentLoading(true);

    if (money < 20 || money > 1000) {
      toast.error("You cannot deposit less than ₹20 and more than ₹1000", {
        autoClose: 6000,
      });
    } else {
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }

      const result = await axios.post(
        "https://api.coinstorey.com/payment/createPaymentOrder",
        {
          pid: userData.profile_data._id,
          walletId: data._id,
          amount: Number((money * 100).toFixed(0)),
          currency: "INR",
        }
      );

      setPaymentLoading(false);
      if (!result) {
        alert("Server error. Are you online?");

        return;
      }

      const { amount, id, currency } = result.data.data.razorPayResponse;
      const orderId = result.data.data.orderSaved._id;
      const options = {
        key: process.env.RAZORPAY_LIVE_KEY, // Enter the Key ID generated from the Dashboard
        amount: amount.toString(),
        currency: currency,
        name: "CoinStorey",
        description: "Lock your portfolio✔",
        // image: { logo },
        order_id: id,
        handler: async function (response) {
          const data = {
            orderId,
            orderCreationId: id,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpayOrderId: response.razorpay_order_id,
            razorpaySignature: response.razorpay_signature,
          };

          const result = await axios.post(
            "https://api.coinstorey.com/payment/verifyPayment",
            data
          );
          if (result.data?.success) {
            Swal.fire({
              icon: "success",
              title: "Payment Successful",
              customClass: {
                container: "swal__container",
                closeButton: "swal__button",
                // icon: '...',
                // image: '...',
                // content: '...',
                // htmlContainer: '...',
                // input: '...',
                // inputLabel: '...',
                // validationMessage: '...',
                // actions: '...',
                // confirmButton: '...',
                // denyButton: '...',
                // cancelButton: '...',
                // loader: '...',
                // footer: '....',
                // popup: '...',
                // header: '...',
                // title: '...',
              },
            });
            getAmountInWallet();
          }
        },
        prefill: {
          name: userData.profile_data.name,
          email: userData.profile_data.email,
          contact: "9999999999",
        },
        notes: {
          address: "Kolkata",
        },
        theme: {
          color: "#61dafb",
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    }
  }

  const fetchMoreData = () => {
    setTimeout(() => {
      getAmountInWallet(pageNo);
      setPageNo(pageNo + 1);
    }, 1500);
  };
  return (
    <div className={styles.transactionContainer}>
      <section>
        
        <section className={styles.section1} style={{textAlign: 'center'}}>
            <h2>Wallet Balance</h2>
            <h3 style={{margin: '10px 0'}}>
              <NumberFormat
                value={formatPrice(
                  data.depositAmt  +
                    data.referAmt +
                    data.contestComAmt +
                    data.contestWinAmt
                )}
                displayType={"text"}
                thousandSeparator={true}
                prefix="₹"
              />
            </h3>
            <p>Deposits + winnings + commissions</p>
          </section>
          
        
      <div className={styles.TransactionSectionItem} style={{flexDirection: 'row'}}>
     
         <button className={styles.main_buttons}  onClick={() => setShowInput(!showInput)}>
          Add Money
            </button>     <button onClick={() => history.push("/withdraw")} className={styles.main_buttons} style={{background:"#8d0792"}} >
              Withdraw
            </button>
      </div>

    
        {showInput && (
          <div className={styles.TransactionSectionItem}>
            <section className={styles.section1}>
              <p>Enter Amount to be deposited</p>
              <input
                type="number"
                value={money}
                onChange={(e) => setMoney(e.target.value)}
              />
            </section>
            <section className={styles.section2}>
              <button onClick={displayRazorpay} disabled={paymentLoading}>
                Deposit{" "}
                {paymentLoading && (
                  <div
                    className="loader1"
                    style={{
                      height: "20px",
                      width: "20px",
                      display: "inline-block",
                      border: "3px solid #f3f3f3",
                      borderTop: "3px solid rgba(69, 170, 67, 1)",
                      marginLeft: "5px",
                    }}
                  ></div>
                )}
              </button>
            </section>
          </div>
        )}

        <div className={styles.TransactionSectionItem}>
          <section className={styles.section1}>
            <p>Amount Added</p>
            <p>
              <NumberFormat
                value={formatPrice(data.depositAmt )}
                displayType={"text"}
                thousandSeparator={true}
                prefix="₹"
              />
            </p>
          </section>
          <section className={styles.section2}>
            <ReactTooltip place="top" effect="float" multiline={true} />
            <FcInfo
              size={26}
              data-tip="Money you have deposited<br />in the wallet that can be used to join<br />contests but can't be withdrawn directly"
            />
          </section>
        </div>
        <div className={styles.TransactionSectionItem}>
          <section className={styles.section1}>
            <p>Winnings</p>
            <p>
              <NumberFormat
                value={formatPrice(data.contestWinAmt)}
                displayType={"text"}
                thousandSeparator={true}
                prefix="₹"
              />
            </p>
          </section>
          <section className={styles.section2}>
            <ReactTooltip place="top" effect="float" multiline={true} />
            <FcInfo
              size={26}
              data-tip=" Money you have won by<br />playing games that can be withdrawn<br />or re-use to join any contests."
            />
          </section>
        </div>
        <div className={styles.TransactionSectionItem}>
          <section className={styles.section1}>
            <p>Commission</p>
            <p>
              <NumberFormat
                value={formatPrice(data.referAmt + data.contestComAmt)}
                displayType={"text"}
                thousandSeparator={true}
                prefix="₹"
              />
            </p>
          </section>
          <section className={styles.section2}>
            <ReactTooltip place="top" effect="float" multiline={true} />
            <FcInfo
              size={26}
              data-tip="Money you have earned via<br />commissions that can be withdrawn or<br />re-use to join any contests"
            />
          </section>
        </div>
       
          <div className={styles.TransactionSectionItem}>
            <section className={styles.section1}>
              <p>Lock Amount</p>
              <p>
                <NumberFormat
                  value={formatPrice(data.lockAmt)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix="₹"
                />
              </p>
              <Link to={"/wallet/withdraw/details"} style={{marginTop:"5px",color:"#8d0792",cursor:"pointer"}}>view pending withdraw details</Link>
            </section>
            <section className={styles.section2}>
              <ReactTooltip place="top" effect="float" multiline={true} />
              <FcInfo
                size={26}
                data-tip="Withdrawn money which is processing"
              />
            </section>
          </div>
        
</section>
      <section>
        <h2 style={{textAlign: 'center'}}>Transactions</h2>
        <div
          className={styles.transactionsHistory}
          id="scrollableDiv"
          style={{ position: "relative" }}
        >
          {data.transactions && data.transactions.length > 0 ? (
            <InfiniteScroll
              dataLength={data.transactions && data.transactions.length}
              next={fetchMoreData}
              loader={<Loader />}
              endMessage={
                <p style={{ margin: "20px 0" }}>
                  Wait! You reached last, no more transactions{" "}
                </p>
              }
              hasMore={data?.hasTransactions ? true : false}
              // scrollThreshold="-300px"
              scrollableTarget="scrollableDiv"
              // style={{ marginBottom: "50px" }}
            >
              {data.transactions && data.transactions.length > 0 ? (
                data.transactions.map((c) => (
                  <TransactionItem
                    key={c._id}
                    desc={c.desc}
                    date={moment(c.date).format("ll")}
                    id={c._id}
                    type={c.type}
                    amt={c.amt}
                    currencySymbol={`$`}
                    exchangeRate={exchangeRate}
                  />
                ))
              ) : (
                <></>
              )}
            </InfiniteScroll>
          ) : (
            <center>
              <p style={{ marginTop: "10px" }}>Nothing to Show</p>
            </center>
          )}{" "}
        </div>
      </section>
    </div>
  );
};

export default withRouter(Transaction);
